import DadosComponent from './dados.component'

export default DadosComponent
